import React from 'react';
import { EditGroupButton } from 'modules/payrollProcessorHub/components/PayrollAction/EditGroupButton';
import { ICalculationGroupSidebarActionsProps } from 'modules/payrollProcessorHub/components/PayrollSheetDetailSidebar/components/calculationGroup/batch/ICalculationGroupSidebarActionsProps';

export const CalcGroupMissingActions = ({ calculationGroup }: ICalculationGroupSidebarActionsProps) => (
    <EditGroupButton calculationGroup={calculationGroup} />
);
